import Vue from 'vue'
import _ from 'lodash'
var host = process.env.VUE_APP_API

/* eslint-disable */
export default {
  namespaced: true,
  state: {
    loading: true,
    guests: [],
    passes: []
    // guest: {
    //   items: []
    // }
  },
  actions: {
    getGuests ({commit, rootState, dispatch}) {
      console.log('getGuests: ')
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
      Vue.http
        .get(host + '/guests/' + rootState.hotels.activehotel._id,
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          // console.log('getGuests2 ',response.data)
          dispatch('ombrelloni/getOmbrelloni', null, {root: true}).then(data => {
            // commit('LOAD_GUESTS', response.data.guests)
            commit('LOAD_GUESTS', _.filter(response.data.guests, (guest) => {
              guest.ombrelloni = _.filter(guest.ombrelloni, (o) => {
                return _.some(rootState.ombrelloni.ombrelloni, {_id: o.ombrelloneid})
              })
              // console.log(guest.name, guest.ombrelloni.length)
              return guest.ombrelloni.length > 0
            }))
          })
          commit('SET_LOADING', false)
        }, (error) => {
          commit('SET_LOADING', false)
          this._vm.$notify({
            title: 'Errore connessione',
            message: 'prego ri vare',
            type: 'error'
          })
        })
      })
    },
    updateGuest ({rootState, dispatch}, data) {
      // console.log('updateGuest: ', data)
      Vue.http
        .post(process.env.VUE_APP_API + '/guest/update', { guest: data.guest, hotel: rootState.hotels.activehotel, seat: data.seat, range: data.range, today: data.today },
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          // console.log('updateGuest2 ',response.data)
          dispatch('getGuests')
          dispatch('ombrelloni/getOmbrelloni', null, {root: true})
          if (data.guest.passid) {
            dispatch('updatePass', data.guest.passid)
          }
        })
    },
    deleteGuest ({rootState, dispatch}, data) {
      // console.log('deleteGuest: ', data)
      Vue.http
        .post(process.env.VUE_APP_API + '/guest/delete', {data: data},
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          // console.log(response.data)
          dispatch('getGuests')
          dispatch('ombrelloni/getOmbrelloni', null, {root: true})
        })
    },
    addSeat ({rootState, dispatch}, data) {
      // console.log('addSeat: ', data)
      Vue.http
        .post(process.env.VUE_APP_API + '/guest/addSeat', { add: data.add.guest, guest: data.guest, hotel: rootState.hotels.activehotel, seat: data.seat, range: data.range },
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          // console.log(response.data)
          dispatch('getGuests')
          dispatch('ombrelloni/getOmbrelloni', null, {root: true})
          console.log(_.find(rootState.hotels.hotels, function (o) {
            return o._id === rootState.hotels.activehotel._id
          }))
          // dispatch('hotels/getHotels', null, {root: true})
        })
    },
    checkoutGuest ({rootState, dispatch, commit}, data) {
      // console.log('checkoutGuest: ', data)
      commit('SET_LOADING', true)
      Vue.http
        .post(process.env.VUE_APP_API + '/guest/checkoutGuest', { guest: data.guest },
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          // console.log('updateGuest2 ',response.data)
          dispatch('getGuests')
          dispatch('ombrelloni/getOmbrelloni', null, {root: true})
          commit('SET_LOADING', false)
        })
    },
    getPasses ({state, rootState, dispatch, commit}) {
      // console.log('getPasses: ')
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/hotel/passes', {hotelid: rootState.hotels.activehotel._id},
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            commit('LOAD_PASSES', response.data.passes)
            resolve('ok')
            // dispatch('getHotels')
            commit('SET_LOADING', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    generatePass ({rootState, dispatch, commit}, data) {
      // console.log('generatePass: ', data, rootState.hotels.activehotel)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/api/generatepass', { guest: data.guest, hotel: rootState.hotels.activehotel },
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log('generatepass response: ',response.data)
            dispatch('getGuests')
            dispatch('getPasses')
            dispatch('ombrelloni/getOmbrelloni', null, {root: true})
            commit('SET_LOADING', false)
            resolve('ok')
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
        })
    },
    sendPushMessage ({state, rootState, dispatch, commit}, data) {
      // console.log('sendPushMessage: ', data)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/api/pass/sendpushmessage', {matchedGuest: data.matchedGuest, message: data.message},
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            dispatch('updatePass', data.matchedGuest.passid)
            resolve('ok')
            // dispatch('getHotels')
            commit('SET_LOADING', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    updatePass ({rootState, dispatch, commit}, data) {
      // console.log('updatePass: ', data)
      commit('SET_LOADING', true)
      Vue.http
        .post('https://dexter.node.systems:44567/api/pass/update', { passid: data },
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          // console.log('updatePass response: ',response.data)
          // dispatch('getGuests')
          // dispatch('ombrelloni/getOmbrelloni', null, {root: true})
          commit('SET_LOADING', false)
        })
    },
    sendPushMessages ({state, rootState, dispatch, commit}, data) {
      // console.log('sendPushMessages: ', data)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/api/pass/sendpushmessages', {message: data.message, hotel: rootState.hotels.activehotel},
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            // dispatch('updatePass', data.matchedGuest.passid)
            resolve('ok')
            // dispatch('getHotels')
            commit('SET_LOADING', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    sendPassMail ({state, rootState, dispatch, commit}, data) {
      // console.log('sendPassMail: ', data)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/api/pass/send', {email: data.email, hotel: rootState.hotels.activehotel, passid: data.matchedGuest.passid},
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            // dispatch('updatePass', data.matchedGuest.passid)
            resolve('ok')
            // dispatch('getHotels')
            commit('SET_LOADING', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    convert ({rootState}) {
      // console.log('convert: ')
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/guests/convert', rootState.hotels.activehotel,
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            resolve('convert ok')
            // console.log(response.data)
            // dispatch('getHotels')
          })
      })
    },
    reset ({rootState}) {
      // console.log('reset: ')
      Vue.http
        .post(process.env.VUE_APP_API + '/guests/reset', rootState.hotels.activehotel,
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          // console.log(response.data)
          // dispatch('getHotels')
        })
    }
  },
  mutations: {
    LOAD_GUESTS (state, response) {
      // console.log(response)
      state.guests = response
      state.loading = false
    },
    LOAD_PASSES (state, response) {
      state.passes = response
    },
    SET_LOADING (state, data) {
      state.loading = data
    }
  },
  getters: {}
}
